"use client";
import { ThemeContext, ThemeContextType } from "@/providers/ThemeProvider";
import { useContext } from "react";

export const useTheme = (): ThemeContextType | undefined => {
  const context = useContext(ThemeContext);

  return context;
};
